/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatTxtIcon24Solid = forwardRef('FileFormatTxtIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.201 2.879A3 3 0 0 0 13.08 2H8a4 4 0 0 0-4 4v2h15.855a3 3 0 0 0-.734-1.201l-3.92-3.92Z" }),
        React.createElement("path", { d: "M8 22a4 4 0 0 1-4-4h16a4 4 0 0 1-4 4H8Z" }),
        React.createElement("path", { d: "M8.49 10.01H3.234v1.251h1.89V16.4h1.458v-5.139H8.49V10.01Z" }),
        React.createElement("path", { d: "m15.238 16.4-2.358-3.402 2.097-2.988h-1.62l-1.323 1.953-1.323-1.953H9.064l2.088 2.979-2.35 3.411h1.603l1.61-2.34 1.594 2.34h1.629Z" }),
        React.createElement("path", { d: "M20.812 10.01h-5.256v1.251h1.89V16.4h1.458v-5.139h1.908V10.01Z" })));
});
